import { FC } from 'react';
import Script from 'next/script';
import {
    ADBRIDG_AD_SCRIPT_URL,
    APSTAG_AD_SCRIPT_URL,
    DFP_GPT_AD_SCRIPT_URL
} from '../constants';

const AdScripts: FC<React.PropsWithChildren<unknown>> = () => (
    <>
        <Script
            src={ADBRIDG_AD_SCRIPT_URL}
            strategy="beforeInteractive"
            data-testid="advert_adbridg_script"
        />
        <Script
            src={APSTAG_AD_SCRIPT_URL}
            strategy="beforeInteractive"
            data-testid="advert_apstag_script"
        />
        <Script
            src={DFP_GPT_AD_SCRIPT_URL}
            strategy="beforeInteractive"
            data-testid="advert_dfp_script"
        />
    </>
);

export default AdScripts;
